import React, { useContext, useState } from "react";
import { ButtonProps, AddButton, Aside } from "sprint-common-web";

import { TvSeasonDetails } from "../../../../TvSeriesDetails";
import { TvSeriesPageContext } from "../../context/TvSeriesPageContext";
import { CreateSeasonForm } from "../create-season-form/CreateSeasonForm";

export type AddNewSeasonButtonProps = Pick<ButtonProps, "styles" | "disabled"> & {
    isLabeled?: boolean;
    onClick?(): void;
};

export const AddNewSeasonButton: React.FunctionComponent<AddNewSeasonButtonProps> = (
    props: AddNewSeasonButtonProps
) => {
    const tvSeriesPageContext = useContext(TvSeriesPageContext);
    const [isAsideOpen, setIsAsideOpen] = useState<boolean>(false);

    const handleClick = () => {
        setIsAsideOpen(true);
        if (props.onClick) {
            props.onClick();
        }
    };

    const closeCreateSeasonSidebar = () => {
        setIsAsideOpen(false);
    };

    const handleCreateSeasonFormSubmit = (newSeason: TvSeasonDetails) => {
        tvSeriesPageContext.addNewSeason(newSeason);
        closeCreateSeasonSidebar();
    };

    return (
        <>
            <AddButton
                onClick={handleClick}
                isLabeled={props.isLabeled}
                label="Add"
                disabled={props.disabled || tvSeriesPageContext.isLoading}
                styles={props.styles}
            />
            <Aside isOpen={isAsideOpen} type="form" headerText="Add Season" onDismiss={closeCreateSeasonSidebar}>
                <CreateSeasonForm onCancel={closeCreateSeasonSidebar} onSubmit={handleCreateSeasonFormSubmit} />
            </Aside>
        </>
    );
};
